<template>
  <div>
    <br>
    <span v-if="loading">
      <b-spinner label="Spinning"></b-spinner>
    </span>
    <span v-else>
      <table class="table table-bordered">
      <tr class="text-center">
        <td class="align-middle font-weight-bold light-gray-1" colspan="3">
          PRISMA
        </td>
      </tr>
      <tr class="text-center" v-for="(data, index) in csvData" :key="index">
        <td 
          class="align-middle" 
          :class ="{'font-weight-bold': index1==3, 'light-gray-1': index1!=3 }" v-for="(data1, index1) in data" :key="index1">
          <span>{{data1}}</span>
        </td>
      </tr>
      </table>
    </span>
    <br>
  </div>
</template>

<script>
import axios from 'axios'
import parse from 'csv-parse'

export default {
  name: 'TableLove',
  props: ['gid', 'url'],
  data () { return {
    csvData: [],
    first_empty: false,
    stop: false,
    loading: true,
    skip_first: true,
  } },
  components: {},
  mounted: function(){
    if (this.gid && this.url){
      axios.get(
      this.url + "/pub?gid="+this.gid+"&single=true&output=csv"
    )
    .then((res)=>{
      let vm = this
      let all_empty = false
      parse(res.data)
      .on('readable', function(){
        let record
        while (record = this.read()) {
          all_empty = record.every((r)=>{
            return r.length===0
            })
          if (all_empty){
            vm.first_empty = true
          } else if (vm.skip_first){
            vm.skip_first = false
          } else {
            vm.csvData.push(record.slice(1))
          }
        }
      })
      .on('end', function(){
        vm.loading = false
      })
    })
    .catch((error)=>{
      this.loading = false
      this.csvData = [['Error'],[error.data]]
    })
  }
    },
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.light-gray-1 {
  background-color: #d9d9d9;
}


</style>
